import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { Box, Button, Text } from '@components/common';
import { InputField, PhoneField } from '@components/form';
import API from '@utils/api';
import validationSchema from './schema';
import { getErrors } from '@utils/error';
import { AuthSelectors } from '@redux/AuthRedux';
import { trackBuildingRequest } from '@services/analytics';

class BuildingRequestForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onNext: PropTypes.func,
    user: PropTypes.object
  };

  handleSubmit = async (values, actions) => {
    const { onSubmit } = this.props;
    const { setSubmitting, setErrors } = actions;
    setSubmitting(true);

    try {
      const payload = Object.keys(values).reduce(
        (prev, key) => (values[key] ? { ...prev, [key]: values[key] } : prev),
        {}
      );
      await API.requestProperty(payload);
      trackBuildingRequest(payload);
      setSubmitting(false);
      onSubmit();
    } catch (err) {
      const error = getErrors(err);
      if (error.message) {
        setErrors({
          email: error.message
        });
      } else {
        setErrors(error);
      }
    }
    setSubmitting(false);
  };

  render() {
    const { user } = this.props;
    const { firstName, lastName } = user;
    return (
      <Formik
        initialValues={{
          property_name: '',
          city: '',
          state: '',
          name: `${firstName} ${lastName}`,
          email: '',
          phone: '',
          pm_name: ''
        }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isValid, isSubmitting }) => {
          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <Text mb={4}>
                  The Minte is in new properties each week. Provide your
                  building’s information so that we can contact your Property
                  Manager and bring our service to your home!
                </Text>

                <Field
                  component={InputField}
                  mb={4}
                  name="property_name"
                  type="text"
                  label="Property"
                />

                <Field
                  component={InputField}
                  mb={4}
                  name="city"
                  type="text"
                  label="City"
                />

                <Field
                  component={InputField}
                  mb={4}
                  name="state"
                  type="text"
                  label="State"
                />

                <Field
                  component={InputField}
                  mb={4}
                  name="name"
                  type="text"
                  label="Name"
                  readOnly
                />

                <Text fontSize={0} px={4} mb={4} color="darkGray">
                  Property management contact information
                </Text>

                <Field
                  component={InputField}
                  mb={4}
                  name="pm_name"
                  type="text"
                  label="Name"
                />

                <Field
                  component={PhoneField}
                  mb={4}
                  name="phone"
                  type="text"
                  label="Phone"
                />

                <Field
                  component={InputField}
                  mb={4}
                  name="email"
                  type="text"
                  label="Email"
                />

                <Button
                  flex={1}
                  mb={4}
                  type="submit"
                  disabled={!isValid || isSubmitting}
                >
                  Done
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state)
});

export default connect(mapStatesToProps)(BuildingRequestForm);
